import { map, switchMap, take } from "rxjs/operators";

import { GetActiveOrderQuery } from "../generated-types";
import { SET_CONSOLIDATED_FEED_ORDER } from "../graphql/consolidated-feed.graphql";
import { GET_ACTIVE_ORDER } from "../../core/providers/active/active.service.graphql";
import { DataService } from "../../core/providers/data/data.service";
import { shouldOrderBeConsolidatedFeed } from "./consolidated-feed-cart";

export async function setConsolidatedFeedOrderFlag(
    dataService: DataService,
    consolidated: boolean,
): Promise<GetActiveOrderQuery["activeOrder"]> {
    const activeOrder = await dataService
        .mutate<
            { setConsolidatedFeedOrder: boolean },
            { consolidated: boolean }
        >(SET_CONSOLIDATED_FEED_ORDER, { consolidated })
        .pipe(
            switchMap(() =>
                dataService.query<GetActiveOrderQuery>(
                    GET_ACTIVE_ORDER,
                    undefined,
                    "network-only",
                ),
            ),
            take(1),
            map(({ activeOrder }) => activeOrder),
        )
        .toPromise();
    dataService.refetchQueries(["GetActiveOrder"]);
    return activeOrder;
}

export async function syncConsolidatedFeedOrderFlag(
    dataService: DataService,
    order: GetActiveOrderQuery["activeOrder"] | null | undefined,
): Promise<GetActiveOrderQuery["activeOrder"] | null | undefined> {
    const consolidated = shouldOrderBeConsolidatedFeed(order?.lines ?? []);
    return setConsolidatedFeedOrderFlag(dataService, consolidated);
}

export async function syncConsolidatedFeedOrderFlagFromActiveOrder(
    dataService: DataService,
): Promise<GetActiveOrderQuery["activeOrder"] | null | undefined> {
    const { activeOrder } = await dataService
        .query<GetActiveOrderQuery>(GET_ACTIVE_ORDER, undefined, "network-only")
        .pipe(take(1))
        .toPromise();
    return syncConsolidatedFeedOrderFlag(dataService, activeOrder);
}

export async function markOrderAsConsolidatedFeed(
    dataService: DataService,
): Promise<GetActiveOrderQuery["activeOrder"]> {
    return setConsolidatedFeedOrderFlag(dataService, true);
}
